// ======================================================================
// File Name       : ServiceGroupDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';

class ServiceGroupDetail extends Component {
  render() {
    const { editingServiceGroup: { serviceGroupName }, serviceGroupSecernId } = this.props;
    return (
      <div>
        {/* Step 11.0.0 START */}
        {serviceGroupSecernId && (
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>サービスグループID</Col>
            <Col as={Form.Label} sm={9}>{serviceGroupSecernId}</Col>
          </Form.Group>
        )}
        {/* Step 11.0.0 END */}
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>サービスグループ名</Col>
          <Col as={Form.Label} sm={9}>{serviceGroupName}</Col>
        </Form.Group>
      </div>
    );
  }
}

ServiceGroupDetail.propTypes = {
  editingServiceGroup: PropTypes.shape().isRequired,
};

export default ServiceGroupDetail;
